import React from 'react';
import TextField from "material-ui/TextField";
import PropTypes from "prop-types";

const PmTicketSignalLevelFields = (props) => {
    const {
        value,
        name,
        error,
        id,
        handleValueChange,
    } = props;

    return (
        <div className="row">
            <div className="col s12">
                <TextField
                    fullWidth
                    floatingLabelText={name}
                    value={value}
                    onChange={(e) => handleValueChange(e.target.value, id)}
                />
                {
                    error ?
                        <span style={{ color: "red" }}>
                            {error}
                        </span> :
                        null
                }
            </div>
        </div>
    );
};

PmTicketSignalLevelFields.propTypes = {
    value: PropTypes.string,
    hasChannelNumbers: PropTypes.bool,
    name: PropTypes.string,
    channelNumber: PropTypes.string,
    tapLevelValue: PropTypes.string,
    tapLevelError: PropTypes.string,
    groundBlockLevelValue: PropTypes.string,
    groundBlockLevelError: PropTypes.string,
    handleValueChange: PropTypes.func,
};

export default PmTicketSignalLevelFields;


// WEBPACK FOOTER //
// ./src/components/signal-levels/PmTicketSignalLevelFields.js